import React from 'react';
import { Button as MuiButton } from '@mui/material';
import LocalSeeIcon from '@mui/icons-material/LocalSee';

const ButtonStyles = {
  width: '100%',
  backgroundColor: '#0acf97',
  margin: '8px',
  padding: '8px 12px',
};

export const AddPhotoButton = (props, { size = 'small' }) => {
  return (
    <MuiButton
      onClick={props.onUpload}
      disabled={props.disabled}
      size={size}
      sx={ButtonStyles}
      component="label"
      role={undefined}
      variant="contained"
      tabIndex={-1}
      startIcon={<LocalSeeIcon />}
    >
      {props.children}
    </MuiButton>
  );
};
